import { Layout } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom'
import { HeaderComponent } from '../components'
import { ApiMethodEnum, UserTypeEnum } from '../models'
import { RootState } from '../stores'
import { loadApis } from '../stores/actions'
const { Content } = Layout

interface Props extends RouteProps {
  component: any
}

export const PrivateRoute: React.FC<Props> = ({
  component: Component,
  ...rest
}) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const { profile } = useSelector((state: RootState) => state.auth)
  const { apis, isApisLoaded } = useSelector((state: RootState) => state.api)
  React.useEffect(() => {
    if (!isApisLoaded) {
      dispatch(loadApis())
    }
    // eslint-disable-next-line
  }, [])

  if (
    isApisLoaded &&
    profile?.userType.type !== UserTypeEnum.ADMIN &&
    !['/profile'].includes(location.pathname)
  ) {
    if (
      !apis.filter(
        (item) =>
          item.method === ApiMethodEnum.GET &&
          (location.pathname === '/'
            ? ['/tank-statistic', '/fuel-statistic'].includes(item.path)
            : item.path === location.pathname)
      ).length
    ) {
      return <Redirect to="/profile" />
    }
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        profile ? (
          <Layout style={{ width: '100%', height: '100%' }}>
            <Layout style={{ background: 'white' }}>
              <HeaderComponent />
              <Content style={{ padding: '0 16px', marginTop: '60px' }}>
                <Component {...props} />
              </Content>
            </Layout>
          </Layout>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  )
}
